<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">


        <div
          style="display: flex;justify-content: flext-end;margin-right: 20px;align-items: center;margin-top: 20px;padding:20px;width: 100%;">

          <div v-if="content" style="display: flex;justify-content: flex-end;width: 95%;">
<!--            <el-tooltip class="item" effect="dark" content="将报告内容复制到剪贴板." placement="top">
              <el-button type="success" round @click="copyReport()">复制报告</el-button>
            </el-tooltip> -->


            <el-tooltip class="item" effect="dark" content="将修改的报告内容保存." placement="top">
              <el-button type="warning" round @click="saveReport()">保存报告</el-button>
            </el-tooltip>

          </div>
          <div v-else style="display: flex;align-items: flex-end;justify-content: flex-end;width: 95%;">
            <el-tooltip class="item" effect="dark" content="给成绩单上增加通知,查询结果后面显示." placement="top">
              <el-button type="success" round @click="generateReport()">生成考试成绩报告</el-button>
            </el-tooltip>
          </div>

        </div>
        <el-divider content-position="center"><span style="font-size: 22px;">考试成绩分析报告</span></el-divider>
        <div style="padding: 10px;">

          <div>
            <div v-if="content">
              <div style="color:red;font-size: 16px;margin: 10px;">
                注意：成绩分析报告由系统依据本次所有学生的成绩自动生成，使用前务必认真仔细阅读内容并修改后方可使用。修改完的报告记得要保存哦~</div>

              <div style="padding:20px;" v-html="content"></div>
              <!-- <textarea rows="30" v-model="content" style="width:96%;border: 1px solid lightgray;padding:10px;"></textarea> -->

            </div>
            <div v-else>
              <div style="margin: 20px;text-align: center;font-size: 18px;font-weight: bold;">暂无成绩分析报告！</div>
              <div style="margin: 20px;text-align: center;font-size: 14px;">成绩报告可由系统自动生成，报告内容主要包括成绩分析、优缺点分析以及改进建议！</div>

            </div>
          </div>

        </div>

      </el-col>
    </el-row>
    <el-row>

    </el-row>

    <el-dialog title="重要提示" :visible.sync="generateConfirmDialogVisible" width="30%">
      <span>生成报告需要十几秒甚至更多的时间，生成时需要您耐心等待，您确定要生成吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="generateConfirmDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="generateReportAction()">立即生成报告</el-button>
      </span>
    </el-dialog>



  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  export default {
    components: {
      MenuList,
      Header
    },
    created() {
      this.username = this.$session.get('USERNAME') // 获取session
      this.examID = this.$route.params.id
      // console.log('传递过来的参数是:' + this.examID)
      this.loadData()
    },
    // 搜索数据
    computed: {
      filterData: function() {
        // let that = this
        // var input = this.condition && this.condition.toLowerCase()
        // var items = this.tableData
        // var items1
        // if (input) {
        //   items1 = items.filter(function(item) {
        //     return Object.keys(item).some(function(key1) {
        //       return String(item[key1])
        //         .toLowerCase()
        //         .match(input)
        //     })
        //   })
        // } else {
        //   items1 = items
        // }
        // that.currentItems = items1
        // return items1
        var items = this.tableData
        return items
      }
    },
    data() {
      return {

        username: '',
        examID: '',
        content: '',
        generateConfirmDialogVisible: false

      }
    },
    methods: {
      copyReport() {
        navigator.clipboard
          .writeText(this.content)
          .then(() => {
            this.$message.success("复制成功");
          })
          .catch((err) => {
            // 复制失败
            console.error("复制失败");
          })
      },



      loadData() {
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/score/web/_load_exam_analysis_content.jsp'
        this.axios.get(requestUrl, {
            params: {
              exam_id: that.examID,
            }
          }).then(function(response) {

            if (response.data.result == '1') {
              that.content = response.data.analysis_result
            } else {
              that.content = ''
            }


            that.$forceUpdate()

            load.close()
          })
          .catch(function(error) {
            console.log(error)

            load.close()
          })
      },
      saveReport() {
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/score/web/_update_exam_analysis_content.jsp'
        this.axios.get(requestUrl, {
            params: {
              exam_id: that.examID,
              content: that.content
            }
          }).then(function(response) {

            that.loadData()

            that.$message.success("保存成功");

            load.close()
          })
          .catch(function(error) {
            console.log(error)

            load.close()
          })
      },
      generateReport() {
        this.generateConfirmDialogVisible = true

      },
      generateReportAction() {
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/score/web/_generate_exam_analysis_result.jsp'
        this.axios.get(requestUrl, {
            params: {
              exam_id: that.examID,
            }
          }).then(function(response) {
            that.generateConfirmDialogVisible = false

            that.loadData()

            that.$message.success("生成成功");

            load.close()
          })
          .catch(function(error) {
            console.log(error)

            load.close()
          })
      }
    }
  }
</script>

<style>
  .searchStyle {
    display: flex;
    width: 200px;
    align-items: center;

  }

  .actionBarStyle {
    display: flex;
    justify-content: space-between;
  }

  .titleStyle {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px;
  }

  .addRecordStyle {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .searchBarStyle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/exam_report.vue